/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormControl,
  FormErrorMessage,
  FormLabel,
  InputGroup,
} from '@chakra-ui/react';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import InputReactMask from 'react-input-mask';

interface IInputMaskProps extends Omit<ChakraInputProps, 'size'> {
  name: string;
  label?: string;
  mask: string;
  maskChar?: string;
}

//Tipagem com erro devido a versão do react-input-mask
const InputMaskAny = InputReactMask as any;

export const InputMask: React.FC<IInputMaskProps> = ({
  name,
  label,
  mask,
  maskChar = null,
  ...rest
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormControl isInvalid={!!errors[name]}>
      {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      <InputGroup>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <InputMaskAny mask={mask} maskChar={maskChar} {...field}>
              {(inputProps: any) => (
                <ChakraInput id={name} {...inputProps} {...rest} bg="white" />
              )}
            </InputMaskAny>
          )}
        />
      </InputGroup>
      <FormErrorMessage>
        {errors?.[name] && (errors[name]?.message as string)}
      </FormErrorMessage>
    </FormControl>
  );
};
